(() => {
  const dialog = document.getElementById('shf-product-dialog');
  if (!dialog) return;
  const data = {
    ivory: {title:'White / Original tee',desc:'Comfort Colors 1717. Heavyweight garment-dyed cotton, relaxed fit, and a larger, centred 9-inch Shafrini logo printed on the front.',options:['S','M','L','XL','2XL']},
    navy: {title:'True Navy / Reverse tee',desc:'Comfort Colors 1717 in the deeper True Navy colour with the ivory, teal and gold reverse logo. Heavyweight cotton with a relaxed fit and a larger, centred 9-inch logo.',options:['S','M','L','XL','2XL']},
    'white-mug': {title:'White / Original mug',desc:'The original Shafrini logo on both sides of a glossy white ceramic mug. Dishwasher- and microwave-safe.',options:['11 oz','15 oz']},
    'navy-mug': {title:'Blue / Reverse mug',desc:'A blue ceramic mug with the reverse Shafrini logo. We are developing this design for a later release.',options:['Coming soon']},
    patch: {title:'Navy / Ivory patch',desc:'A navy adjustable snapback with the original logo on an ivory patch. Coming in a later release.',options:['Coming soon']},
    embroidered: {title:'Reverse embroidery',desc:'Dark Navy Yupoong 6089M with direct Shafrini embroidery in ivory, teal and gold. Structured, high-profile crown, flat visor and adjustable snap closure.',options:['Dark Navy · one size, adjustable']}
  };
  const variants = {
    embroidered:['67619420635446'],
    ivory:['67616705413430','67616705446198','67616705478966','67616705511734','67616705544502'],
    navy:['67616705577270','67616705610038','67616705642806','67616705675574','67616705708342'],
    'white-mug':['67616705741110','67616705773878']
  };
  const marketData = JSON.parse(document.getElementById('shf-market-data')?.textContent || '{"variants":{}}');
  let market = marketData;
  let activeKey;
  const select = document.getElementById('shf-dialog-option');
  const links = JSON.parse(document.getElementById('shf-product-links')?.textContent || '{}');
  const link = document.getElementById('shf-shop-link');
  const priceFor = (key,index = 0) => market.variants[variants[key]?.[index]]?.price || 'Price pending';
  function refreshCards() {
    document.querySelectorAll('[data-card-price]').forEach(node => {
      const key = node.dataset.cardPrice;
      const price = priceFor(key);
      node.textContent = (key === 'white-mug' && price !== 'Price pending' ? 'From ' : '') + price;
    });
    document.querySelectorAll('[data-market-currency]').forEach(node => { node.textContent = market.currency; });
    if (activeKey) refreshOption();
  }
  function refreshOption() {
    document.getElementById('shf-dialog-price').textContent = priceFor(activeKey, select.selectedIndex);
    const destination = links[activeKey];
    link.hidden = !destination;
    document.getElementById('shf-coming-soon').hidden = !!destination;
    if (destination) {
      const url = new URL(destination, location.origin);
      const id = variants[activeKey]?.[select.selectedIndex];
      if (id) url.searchParams.set('variant',id);
      link.href = url.href;
    }
  }
  document.querySelectorAll('[data-product]').forEach(button => button.addEventListener('click', () => {
    activeKey = button.dataset.product;
    const active = data[activeKey];
    document.getElementById('shf-dialog-title').textContent = active.title;
    document.getElementById('shf-dialog-description').textContent = active.desc;
    const image = button.querySelector('img,.shf-hat-crop').cloneNode(true);
    document.getElementById('shf-dialog-art').replaceChildren(image);
    select.replaceChildren(...active.options.map(text => { const option = document.createElement('option'); option.textContent = text; return option; }));
    refreshOption();
    dialog.showModal();
  }));
  select.addEventListener('change', refreshOption);
  dialog.querySelector('.shf-close-dialog').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  const country = document.getElementById('ShafriniCountry');
  if (country && marketData.previewMarkets) {
    const requested = new URLSearchParams(location.search).get('country_code');
    if (requested && marketData.previewMarkets[requested]) country.value = requested;
    const applyPreviewMarket = () => {
      market = marketData.previewMarkets[country.value];
      refreshCards();
      document.querySelectorAll('[data-preview-currency-note]').forEach(note => {
        note.textContent = country.value === 'US'
          ? 'Private review: USD prices are estimates. Shopify will calculate the live exchange rate at launch.'
          : 'Private review: planned CAD prices. Ordering is not available.';
      });
    };
    country.addEventListener('change', applyPreviewMarket);
    country.form.addEventListener('submit', event => { event.preventDefault(); applyPreviewMarket(); });
    applyPreviewMarket();
  } else {
    refreshCards();
  }
})();
